(() => {
  'use strict';
  if (customElements.get('fultons-quantity')) return;
  customElements.define('fultons-quantity', class extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[name="quantity"]');
      this.decrease = this.querySelector('[data-quantity-decrease]');
      this.increase = this.querySelector('[data-quantity-increase]');
      if (!this.input || !this.decrease || !this.increase) return;
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.decrease.addEventListener('click', () => this.change(-1), options);
      this.increase.addEventListener('click', () => this.change(1), options);
      this.input.addEventListener('input', () => this.sync(), options);
      this.input.addEventListener('change', () => this.sync(), options);
      this.observer?.disconnect();
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.input, { attributes: true, attributeFilter: ['disabled', 'min', 'max', 'step', 'value'] });
      this.sync();
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
    sync() {
      const min = this.input.min === '' ? 1 : Number(this.input.min);
      const max = this.input.max === '' ? Infinity : Number(this.input.max);
      const step = Number(this.input.step) > 0 ? Number(this.input.step) : 1;
      const lastAllowed = Number.isFinite(max) ? min + Math.floor((max - min) / step) * step : Infinity;
      const value = Number(this.input.value);
      this.decrease.disabled = this.input.disabled || value <= min;
      this.increase.disabled = this.input.disabled || value >= lastAllowed;
    }
    change(direction) {
      if (this.input.disabled) return;
      direction < 0 ? this.input.stepDown() : this.input.stepUp();
      this.input.dispatchEvent(new Event('input', { bubbles: true }));
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
      this.sync();
    }
  });
})();
